import { render } from "./EntityActions.vue?vue&type=template&id=8ee58576&scoped=true"
import script from "./EntityActions.vue?vue&type=script&lang=js"
export * from "./EntityActions.vue?vue&type=script&lang=js"

import "./EntityActions.vue?vue&type=style&index=0&id=8ee58576&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee58576"]])

export default __exports__